import { createContext } from 'react'

const ScheduleContext = createContext()

export default ScheduleContext
